import AntAPI from './AntAPI';
import AntAuth from './AntAuth';
import AntCondition from './AntCondition';

// Thêm nhanh (đợt 5 Kế toán, TQ-04): tạo bản ghi nháp qua route `create` chuẩn rồi mở trang chi tiết — đúng thân nút
// Thêm `isQuickCreate` của AntSearchPage. AntSearchPage và menu `+` trên header dùng chung hàm ghép đường dẫn này.

// options: { navigateLink: string | [{ link, when, whenType, field }], navigateField, navigateLinkBySys: { <setting>: [<khi = 1>, <khi khác 1>] } }
// Trả đường dẫn đầy đủ (link + giá trị) hoặc null khi không điều hướng.
export function resolveNavigateLink(options, data, deps = {}) {
    if (!options || !data) return null;
    const isValid = deps.isValid || ((obj, cond) => AntCondition.isValid(obj, cond));
    let value;
    let link;
    if (options.navigateLinkBySys && typeof options.navigateLinkBySys === 'object') {
        const entry = Object.entries(options.navigateLinkBySys)[0];
        if (entry && entry[1] instanceof Array) {
            const busSettings = deps.busSettings || {};
            link = Number(busSettings[entry[0]]) === 1 ? entry[1][0] : entry[1][1];
            value = options.navigateField ? data[options.navigateField] : data.code;
            if (link) link = String(link);
        }
    } else if (options.navigateLink instanceof Array) {
        options.navigateLink.forEach((l) => {
            if (l && l.link) {
                if (l.when && typeof l.when === 'object') {
                    if (!isValid(data, { when: l.when, whenType: l.whenType })) return;
                }
                value = l.field ? data[l.field] : data.code;
                link = String(l.link);
            }
        });
    } else if (options.navigateLink) {
        value = options.navigateField ? data[options.navigateField] : data.code;
        link = String(options.navigateLink);
    }
    if (!link || value === undefined || value === null) return null;
    if (!link.startsWith('/')) link = '/' + link;
    if (!link.endsWith('/')) link = link + '/';
    return link + value;
}

// Mục hiện khi điều kiện `visible` của mục đạt (cùng cách thực đơn đọc điều kiện).
export function visibleItems(items, isVisible) {
    const check = isVisible || ((item) => AntCondition.isVisible(null, item));
    return (items instanceof Array ? items : []).filter((item) => item && item.open && check(item));
}

// Nhóm có mục; nhóm rỗng bỏ. Thứ tự mục theo mảng cấu hình.
export function groupItems(items, groups) {
    return (groups instanceof Array ? groups : [])
        .map((group) => ({ ...group, items: items.filter((item) => item.group === group.key) }))
        .filter((group) => group.items.length > 0);
}

let running = false;

// Bấm mục: một lần tạo tại một thời điểm (bấm hai lần chỉ một bản ghi). Lỗi BE → hộp thông báo, không điều hướng.
export async function run(item, navigate, deps = {}) {
    if (!item || !item.open || running) return null;
    running = true;
    try {
        const api = deps.api || new AntAPI(item.open.module, item.open.table);
        const result = await api.postQuickCreate(item.open.postData);
        if (!result || result.error) {
            if (result && result.error && deps.showAlert) deps.showAlert({ content: result.error });
            return null;
        }
        if (!result.data) return null;
        const busSettings = deps.busSettings || AntAuth.getSessionInfo('bus_settings') || {};
        const link = resolveNavigateLink(item.open, result.data, { busSettings, isValid: deps.isValid });
        if (link && navigate) navigate(link);
        return link;
    } finally {
        running = false;
    }
}

export default { resolveNavigateLink, visibleItems, groupItems, run };
